import { Query } from "@datorama/akita";
import { injectable } from "tsyringe";

import ReviewsListInfoStoreBase, {
    ReviewsListInfoState,
} from "../stores/ReviewsListInfoStoreBase";

@injectable()
class ReviewsListInfoQueryBase extends Query<ReviewsListInfoState> {
    constructor(protected store: ReviewsListInfoStoreBase) {
        super(store);
    }

    totalCount$ = this.select((state) => state.totalCount);
    averageRating$ = this.select((state) => state.averageRating);
    ratesInfo$ = this.select((state) => state.ratesInfo);
    status$ = this.select((state) => state.status);
    error$ = this.selectError();
}

export default ReviewsListInfoQueryBase;
